module.exports = __webpack_public_path__ + "static/media/anara.1f45af36.png";